export default __webpack_public_path__ + "7e9b216832b1da09fb3adfb017d5bd28.svg";